import { IBreadcrumbProps } from "@blueprintjs/core";
import * as React from "react";

interface IBreadcumbContext {
  breadcrumbs: IBreadcrumbProps[];
  setBaseBreadcrumb: (breadCrumb: IBreadcrumbProps[]) => void;
  setDetailsBreadcrumb: (breadCrum: IBreadcrumbProps[]) => void;
}

export const BreadcrumbContext = React.createContext<IBreadcumbContext>(null);

export const BreadcrumbProvider: React.FunctionComponent = ({ children }) => {
  const [baseBreadcrumb, setBaseBreadcrumb] = React.useState<
    IBreadcrumbProps[]
  >([]);
  const [detailsBreadcrumb, setDetailsBreadcrumb] = React.useState<
    IBreadcrumbProps[]
  >([]);

  const breadcrumbs = React.useMemo(
    () => [...baseBreadcrumb, ...detailsBreadcrumb],
    [baseBreadcrumb, detailsBreadcrumb]
  );

  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbs, setBaseBreadcrumb, setDetailsBreadcrumb }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => React.useContext(BreadcrumbContext);
